import { cn } from '@/lib/utils';

type Tone = 'brand' | 'up' | 'down' | 'warn';

interface ProgressBarProps {
  value: number;
  max?: number;
  tone?: Tone;
  label?: string;
  showVal?: boolean;
  size?: 'sm' | 'md' | 'lg';
  hint?: string;
  className?: string;
}

const toneBg: Record<Tone, string> = {
  brand: 'bg-brand',
  up: 'bg-up',
  down: 'bg-down',
  warn: 'bg-warn',
};

export function ProgressBar({
  value,
  max = 100,
  tone = 'brand',
  label,
  showVal = true,
  size = 'md',
  hint,
  className,
}: ProgressBarProps) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  const heightCls = { sm: 'h-1.5', md: 'h-2', lg: 'h-3' }[size];

  return (
    <div className={cn('space-y-1', className)}>
      {(label || showVal) && (
        <div className="flex items-center justify-between text-xs">
          {label && <span className="text-ink-2">{label}</span>}
          {showVal && (
            <span className="num font-medium text-ink-1">
              {value.toFixed(1)}%{hint && <span className="ml-1 text-ink-3">{hint}</span>}
            </span>
          )}
        </div>
      )}
      <div className={cn('w-full overflow-hidden rounded-full bg-bg-3', heightCls)}>
        <div
          className={cn('h-full rounded-full transition-[width] duration-300 ease-out', toneBg[tone])}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
